export function LaboratoryView() {
  return <div>Laboratory view</div>;
}

export const LaboratoryRoute = "/laboratory";
